
//Valentine's Offer text direct static replacement

(function () {
  var OLD_TEXTS = [
    "🥳 I nostri saldi di anniversario sono live ora! 🥳",
    "🥳 La vendita di anniversario è in corso! 🥳"
  ];
 // var NEW_TEXT = "❤️ I nostri saldi di San Valentino sono live ora! ❤️";
//  var NEW_TEXT = "Le nostre offerte di Pasqua sono live, ora 🐰🐣";
// var NEW_TEXT = "🕵️ È arrivata la nostra vendita misteriosa di maggio! 🕵️";
//  var NEW_TEXT = "🤸🎈 Le offerte Play Days sono ora disponibili 🎈👩🏼‍🤝‍👨🏽";
  var NEW_TEXT = "🎒✨ Lo Promozione Smart Start è iniziato ✨📚";

  function replaceText(root) {
    var scope = root || document;

    scope
      .querySelectorAll("h1,h2,h3,h4,h5,h6,#seasonalSaleUp")
      .forEach(function (el) {
        if (OLD_TEXTS.includes(el.textContent.trim())) {
          el.textContent = NEW_TEXT;
        }
      });
  }

  replaceText();

  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === "childList" || m.type === "characterData") {
          replaceText(m.target.nodeType === 1 ? m.target : m.target.parentNode);
        }
      });
    }).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
})();




// (function() {

//   // var NEW_HEADING_TEXT = "🎉 La nostra offerta del Cyber Monday è ora disponibile! 🥳";
//   // var NEW_HEADING_HTML = '🎉 La nostra offerta del <span class="black-friday-allproducts">Cyber Monday</span> è ora disponibile! 🥳';

//   var NEW_HEADING_TEXT = "🥳 La nostra vendita per l’anniversario è ora attiva! 🥳";
//   var NEW_HEADING_HTML = '🥳 La nostra vendita per <span class="black-friday-allproducts">l’anniversario</span> è ora attiva! 🥳';

//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("la vendita anniversario è in corso!") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("oggi") &&
//         lower.includes("anniversario") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/è il nostro\s+anniversario!?/i, "è la nostra vendita per l’anniversario!");
//         newText = newText.replace(
//           /è la nostra vendita per l’anniversario!/,
//           'è la nostra vendita per <span class="black-friday-allproducts">l’anniversario</span>!'
//         );

//         newText = newText.replace(/🎉/g, "🎉").replace(/🎉/g, "🎉");

//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();

// (function() {

//   // var NEW_HEADING_TEXT = "🎉 La nostra offerta del Cyber Monday è ora disponibile! 🥳";
//   // var NEW_HEADING_HTML = '🎉 La nostra offerta del <span class="black-friday-allproducts">Cyber Monday</span> è ora disponibile! 🥳';

//   var NEW_HEADING_TEXT = "🎄 La nostra offerta del Natale è ora disponibile! 🎅";
//   var NEW_HEADING_HTML = '🎄 La nostra offerta del <span class="black-friday-allproducts">Natale</span> è ora disponibile! 🎅';

//   function replaceAnniversaryHeadings(root) {
//     var headings = (root || document).querySelectorAll("h1,h2,h3,h4,h5,h6");

//     headings.forEach(function(h) {
//       var txt = (h.textContent || "").trim();
//       if (!txt) return;
//       var lower = txt.toLowerCase();

//       if (
//         lower.includes("la vendita anniversario è in corso!") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (
//         lower.includes("oggi") &&
//         lower.includes("anniversario") &&
//         !h.querySelector(".black-friday-allproducts")
//       ) {
//         var newText = txt.replace(/è il nostro\s+anniversario!?/i, "è il nostro Natale Sale!");
//         newText = newText.replace(
//           /è il nostro Natale Sale!/,
//           'è il nostro <span class="black-friday-allproducts">Natale</span> Sale!'
//         );

//         newText = newText.replace(/🎉/g, "🎄").replace(/🥳/g, "🎅");

//         h.innerHTML = newText;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//         return;
//       }

//       if (txt === NEW_HEADING_TEXT && !h.querySelector(".black-friday-allproducts")) {
//         h.innerHTML = NEW_HEADING_HTML;
//         if (h.id === "seasonalSale") h.removeAttribute("id");
//       }
//     });
//   }

//   function startReplacing() {
//     replaceAnniversaryHeadings(document);
//     var attempts = 0;
//     var intervalId = setInterval(function() {
//       replaceAnniversaryHeadings(document);
//       if (++attempts > 30) clearInterval(intervalId);
//     }, 500);

//     if (window.MutationObserver) {
//       new MutationObserver(function(mutations) {
//         mutations.forEach(function(m) {
//           m.addedNodes.forEach(function(node) {
//             if (node.nodeType === 1) replaceAnniversaryHeadings(node);
//           });
//         });
//       }).observe(document.body, { childList: true, subtree: true });
//     }
//   }

//   if (document.readyState === "loading") {
//     document.addEventListener("DOMContentLoaded", startReplacing);
//   } else {
//     startReplacing();
//   }

// })();
